import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config;
    if (err.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try { await refreshing; return api(cfg); } catch { /* fallthrough */ }
    }
    return Promise.reject(err);
  }
);

export const errCode = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "validation";
  return "generic";
};

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);
export const evidenceUrl = (path) => `${API}/evidence/${path}`;
export const toHalalas = (sar) => Math.round(Number(sar || 0) * 100);
export const idemKey = () => `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
